export default "__VITE_ASSET__CAyWRq2t__"